<div class="container">
  <div>
    <dxo-breadcrumbs-nav
      *ngIf="breadcrumbs"
      [returnPath]="returnPath"
      [currentPath]="currentPath"
      [links]="links"
    ></dxo-breadcrumbs-nav>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
